import "./Commercial.module.css";
import MainNavigation from "@/reusable_sections/Header";
import HeavyDutySolutions from "./sections/HeavyDutySolutions";
import CoreCleaningSolutions from "./sections/CoreCleaningSolutions";
import LetsCollaborate from "./sections/LetsCollaborate";
import Footer from "@/reusable_sections/Footer";
export default function CommercialPage() {
  return <div>
      <MainNavigation />
      <HeavyDutySolutions />
      <CoreCleaningSolutions />
      <LetsCollaborate />
      <Footer />
    </div>;
}